export { default } from './offer-groups.vue'
